import { render, staticRenderFns } from "./frack1.vue?vue&type=template&id=d3724d96&scoped=true"
import script from "./frack1.vue?vue&type=script&lang=js"
export * from "./frack1.vue?vue&type=script&lang=js"
import style0 from "./frack1.vue?vue&type=style&index=0&id=d3724d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3724d96",
  null
  
)

export default component.exports